import services from './_services'

export default{
  getMedicalAlleyStartsV3Data (query) {
    return services.post(process.env.ROOT_API + '/maa_starts/v3/search', query)
  },
  deleteMedicalAlleyStartsV3Entity (accountID) {
    return services.deleteCall(process.env.ROOT_API + '/maa_starts/v3/' + accountID)
  },
  getMedicalAlleyStartsV3ActivitiesOfAccount (accountID) {
    return services.get(process.env.ROOT_API + '/maa_starts/v3/' + accountID + '/activities')
  },
  //  TAGS
  getTags (tagName) {
    return services.getWithParams(process.env.ROOT_API + '/maa_starts/v3/tags', tagName)
  },
  addNewTag (tagName, tagType) {
    return services.post(process.env.ROOT_API + '/maa_starts/v3/tags', {name: tagName, type: tagType})
  },
  addTagToEntity (entityID, tagID) {
    return services.post(process.env.ROOT_API + '/maa_starts/v3/' + entityID + '/tags/' + tagID)
  },
  removeTagFromEntity (entityID, tagID) {
    return services.deleteCall(process.env.ROOT_API + '/maa_starts/v3/' + entityID + '/tags/' + tagID)
  }
}



// WEBPACK FOOTER //
// ./src/api/medicalAlleyStartsV3.js